import React, { useContext, useEffect, useState } from "react";
import { CgCopy } from "react-icons/cg";
import { AuthContext } from "../context/AuthContext";

function TheLink() {
  const { userData } = useContext(AuthContext);
  const [copy, setCopy] = useState(false);
  const [mount, setMount] = useState(true);

  const copyLink = (e) => {
    setCopy(true);
    e.preventDefault();
    const link = document.getElementById("link-select");
    link.disabled = false;
    link.select();
    document.execCommand("copy");
    link.disabled = true;
    setTimeout(() => {
      if (mount) {
        setCopy(false);
      }
    }, 2000);
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="thelink divContent darktextColor darkdivColor">
      <input
        className="text-link text"
        type="text"
        id="link-select"
        defaultValue={` https://flipcard.xyz/${userData.username}`}
        disabled={true}
      />
      <span className="text">
        {copy ? (
          <span className="textSmall">Copied!</span>
        ) : (
          <CgCopy
            size="1.8em"
            title="Copy Link"
            onClick={(e) => copyLink(e)}
            className="icon-copy"
          />
        )}
      </span>
    </div>
  );
}

export default TheLink;
